import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { Nav, Footer } from "../components"
import styled from "styled-components"

export const Container = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          menuLinks {
            name
            link
          }
        }
      }
    }
  `)

  return (
    <Shell>
      <Nav menuLinks={data.site.siteMetadata.menuLinks} />
      {children}
      <Footer />
    </Shell>
  )
}

const Shell = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  grid-template-rows: var(--header-h) auto auto;
  min-height: 100dvh;
  background: var(--bg);
  color: var(--fg);
`
